module.exports = __webpack_public_path__ + "static/img/14000677.12437063.png";